import { useEffect } from "react";

const PREFIX = "rheumhub:scroll:";

export function useScrollRestore(key: string) {
  useEffect(() => {
    const saved = sessionStorage.getItem(PREFIX + key);
    if (saved !== null) {
      const y = parseInt(saved, 10);
      requestAnimationFrame(() => window.scrollTo({ top: y, behavior: "instant" }));
      sessionStorage.removeItem(PREFIX + key);
    }
    return () => {
      sessionStorage.setItem(PREFIX + key, String(Math.round(window.scrollY)));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
